import {Component, OnInit, Input, Output, EventEmitter, HostListener} from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

  // Ng-Zorro modal wrapped attributes
  @Input() isVisible: true | false = false;
  @Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() nzWrapClassName: string;
  @Input() nzClassName: string;
  // Ng-Zorro modal wrapped attributes

  showModal(): void {
    this.isVisible = true;
  }

  handleClose(): void {
    this.isVisible = false;
    this.isVisibleChange.emit(false);
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') { this.handleClose() }
  }

}
